import { RelativeTime } from 'ui/utility/relativeTime';
import { DateFormat, TimeFormat, localizeDateTime } from 'utils/l10n';
import { TableCell } from '../TableCell';
import type { DateCellProps } from '../types';

export const DateCell = ({
  isRelative = true,
  isUnderlined,
  timestamp,
  ...props
}: DateCellProps) => {
  const date = new Date(timestamp);
  const dateToDisplay = localizeDateTime(date, {
    dateStyle: DateFormat.Short,
    showTime: true,
    timeStyle: TimeFormat.Locale,
  });

  return (
    <TableCell {...props}>
      {isRelative ? (
        <RelativeTime
          isUnderlined={isUnderlined}
          tooltipIsEnabled={!!timestamp}
          timestamp={timestamp}
        />
      ) : (
        <div data-test="table-cell-non-relative-time">{dateToDisplay}</div>
      )}
    </TableCell>
  );
};
